




















import {Component, Prop, Vue} from 'vue-property-decorator'

@Component({})
export default class ModalPopup extends Vue {
  @Prop() public title?: string
  @Prop() public component?: () => Vue
  @Prop() public componentArgs!: any
  @Prop({default: ''}) public width?: string
  private display: string = 'none'

private mounted() {
    this.show()
  }

  private show() {
    this.display = 'block'
  }

  private hide() {
    this.display = 'none'
    this.$emit('closePopup')
  }
}
